import React, { useEffect, useRef, useState, createRef } from "react";
import { axiosInstance } from "../../../axios";
import { json, useNavigate } from "react-router-dom";
import './DraftSummary.css';
import AgendaComponent from "./AgendaComponent";
import SummaryTable from "../GenerationTable/SummaryTable";
import MainTable from "../GenerationTable/MainTable";
import QnATable from "../GenerationTable/QnATable";
import SpinnerLoading from "../../LoadingComponent/SpinnerLoading";
import { AiAnimation, AudioAnimation, AudioSummaryAnimation, RobotLoadingAnimation } from "../../LottieAnimationItems/LAnimations";

function AudioDiarizationComponent({ setActiveTab, navTable, loading, id, showWarning }) {
    const [transcriptSegments, setTranscriptSegments] = useState({ text: [], speakers: [], summary: [], images: {} });
    const [audioProgress, setAudioProgress] = useState(null);
    const [audioData, setAudioData] = useState(null);
    const [editedText, setEditedText] = useState({});
    const [editAgenda, setEditedAgenda] = useState([]);
    const [editTable, setEditTable] = useState([]);
    const [speakerEditText, setSpeakerEditText] = useState([]);
    const [isEditing, setIsEditing] = useState({});
    // State to keep track of checked indexes
    const [checkedIndexes, setCheckedIndexes] = useState([]);
    const [mainTopicSocket, setMainTopicSocket] = useState(null);
    const [detailTopicSocket, setDetailTopicSocket] = useState(null);
    const [agendaSocket, setAgendaSocket] = useState(null);
    const [socketConnection, setSocketConnection] = useState(false);
    const textRefs = useRef([]);


    // change highlighted blocks
    const [highlightedBlocks, setHighlightedBlocks] = useState([]);



    // extract time stamp
    const parseTimestamp = (timestamp) => {
        const [start, end] = timestamp.split(":").map(time => {
            const [minutes, seconds] = time.split("분 ").map(t => parseInt(t, 10));
            return minutes * 60 + seconds; // Convert to total seconds
        });
        return { start, end };
    };


    const handleSummaryClick = (summaryTimestamp) => {
        const { start: summaryStart, end: summaryEnd } = parseTimestamp(summaryTimestamp);
        const blocksToHighlight = [];

        if (transcriptSegments && transcriptSegments.text) {
            transcriptSegments.text.forEach((block, index) => {
                const { start: blockStart, end: blockEnd } = parseTimestamp(block.timestamp);
                // Include the block if it overlaps with the summary timestamp range
                if (blockStart < summaryEnd && blockEnd > summaryStart) {
                    blocksToHighlight.push(index);
                }
            });
        }

        setHighlightedBlocks(blocksToHighlight);

        if (blocksToHighlight.length > 0 && textRefs.current[blocksToHighlight[0]] && textRefs.current[blocksToHighlight[0]].current) {
            textRefs.current[blocksToHighlight[0]].current.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
    };



    // Function to handle checkbox change
    const handleCheckboxChange = (index, isChecked) => {
        if (isChecked) {
            // Add the index to the state array if checked
            setCheckedIndexes([...checkedIndexes, index]);
        } else {
            // Remove the index from the state array if unchecked
            setCheckedIndexes(checkedIndexes.filter(i => i !== index));
        }
    };

    // Speakers name edit state
    const [speakersEditing, setSpeakersEditing] = useState(false);
    const [changedSegment, setChangedSegment] = useState(false);
    const navigate = useNavigate();

    // Fetch Data
    const fetchData = async () => {
        console.log(JSON.stringify({
            update: transcriptSegments
        }))
        try {
            const response = await axiosInstance.post(`audio_diarization/${id}/`, {
                "update": JSON.stringify(transcriptSegments)
            });
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {
                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    const updateSpeakerRequest = async () => {
        try {
            const response = await axiosInstance.post(`update_speaker_name/${id}/`, {
                "speaker_names": transcriptSegments.speakers
            });

            if (response?.status === 200) {

            } else if (response?.data?.detail == 'Unauthenticated!') {
                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    }

    useEffect(() => {
        if (changedSegment) {
            console.log("fetch segment")
            updateSpeakerRequest();
            setChangedSegment(false)
        }
    }, [changedSegment]);

    const handleEditClick = (index) => {
        setIsEditing(prev => ({ ...prev, [index]: true }));
        setEditedText(prev => ({ ...prev, [index]: transcriptSegments.text[index].text }));
    };

    const handleCancel = (index) => {
        setIsEditing(prev => ({ ...prev, [index]: false }));
    };

    const handleSave = (index) => {
        setTranscriptSegments(prevSegments => {
            const updatedSegments = { ...prevSegments };
            updatedSegments.text[index].text = editedText[index];
            return updatedSegments;
        });
        setIsEditing(prev => ({ ...prev, [index]: false }));
        setChangedSegment(true);
    };

    const handleTextChange = (e, index) => {
        setEditedText(prev => ({ ...prev, [index]: e.target.value }));
    };

    const renderTextContent = (item, index) => {
        if (isEditing[index]) {
            return (
                <textarea
                    className="form-control-plaintext"
                    style={{ height: '120px' }}
                    value={editedText[index]}
                    onChange={(e) => handleTextChange(e, index)}
                />
            );
        } else {
            return <p>{item.text}</p>;
        }
    };

    const renderEditButtons = (index) => {
        if (isEditing[index]) {
            return (
                <>
                    <a className="text-success text-decoration-none" onClick={() => handleSave(index)} style={{ marginRight: 15 }}>
                        <i className="fa fa-fw fa-save"></i>
                    </a>
                    <a className="text-danger text-decoration-none" onClick={() => handleCancel(index)}>
                        <i className="fa fa-fw fa-close"></i>
                    </a>
                </>
            );
        } else {
            return (
                // onClick={() => handleEditClick(index)}
                <a className="text-body text-opacity-50 text-decoration-none" onClick={() => handleEditClick(index)}>
                    <i className="fa fa-fw fa-edit"></i>
                </a>
            );
        }
    };

    // Speaker edit handle
    const handleSpeakerEditSave = () => {
        console.log(speakerEditText);

        // Check for empty speakers
        const hasEmptySpeaker = speakerEditText.some(speaker => !speaker.trim());
        if (hasEmptySpeaker) {
            showWarning('참여자 이름이 비어 있습니다.');
            return;
        }

        // Check for duplicate speakers
        const uniqueSpeakers = new Set(speakerEditText);
        if (uniqueSpeakers.size !== speakerEditText.length) {
            showWarning('중복된 참여자 이름이 있습니다.');
            return;
        }

        // 이상한 문자 확인 (예: 특수 문자)
        const validCharRegex = /^[가-힣a-zA-Z0-9\s]+$/;
        const hasInvalidChar = speakerEditText.some(speaker => !validCharRegex.test(speaker));
        if (hasInvalidChar) {
            showWarning('참여자 이름에 이상한 문자가 포함되어 있습니다.');
            return;
        }


        // If all checks pass, update transcriptSegments
        setTranscriptSegments(prevSegments => {
            return {
                ...prevSegments,
                speakers: [...speakerEditText]
            };
        });
        setSpeakersEditing(false);
        setChangedSegment(true);
    };

    const handleSpeakerEditCancel = () => {
        setSpeakersEditing(false);
    }

    // Handle speaker change name
    const handleSpeakerTextChange = (e, index) => {
        setSpeakerEditText(prev => {
            // Create a new array based on the previous state
            let newSpeakers = [...prev];
            // Update the specific element at the index
            newSpeakers[index] = e.target.value;
            // Return the updated array
            return newSpeakers;
        });
    };

    // Handle speaker edit click
    const handleSpeakerEditClick = () => {
        if (audioProgress !== '완료') {
            showWarning("음성 처리중입니다.");
        } else {
            setSpeakersEditing(true);
            setSpeakerEditText(transcriptSegments.speakers);
            console.log('set edited text');
        }
    };

    // Render Text Speaker
    const renderSpeakerName = (item, index) => {
        if (speakersEditing) {
            return (
                // <textarea
                //     className="form-control"
                //     style={{ height: '120px', backgroundColor: '#d5d6d7', borderColor: '#d5d6d7' }}
                //     value={editedText[index]}
                //     onChange={(e) => handleTextChange(e, index)}
                // />
                <input type="text" class="form-control-plaintext" id="title" value={speakerEditText[index]} onChange={(e) => handleSpeakerTextChange(e, index)} />
            );
        } else {
            return item
        }
    };

    // Speaker name edit
    const renderEditSpeaker = () => {
        if (speakersEditing) {
            return (
                <>
                    <div className="ms-auto d-flex ">
                        <a className="text-decoration-none text-success fs-13px " onClick={() => handleSpeakerEditSave()} style={{ marginRight: 15 }}>
                            <i className="fas fa-save fs-4 me-2 my-n1"></i>
                        </a>
                        <a className="text-decoration-none text-danger  fs-13px " onClick={() => handleSpeakerEditCancel()}>
                            <i className="fas fa-close fs-4 me-2 my-n1"></i>
                        </a>
                    </div>

                </>
            );
        } else {
            return (
                // onClick={() => handleEditClick(index)}
                <button
                    class="ms-auto text-decoration-none text-body text-opacity-90 fs-13px d-flex align-items-center button-reset"
                    onClick={() => handleSpeakerEditClick()}><i class="fas fa-edit fs-4 me-2 my-n1"></i> 수정</button>
            );
        }
    };

    // console.log(summaryData);
    useEffect(() => {
        setSocketConnection(true);

        const ws = new WebSocket(`wss://meeting.daewoongai.com/ws/audio_socket/${id}/`);
        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);

            console.log(data.message);
            if (data.audioData && data.audioDiarization && data.detailTopic) {
                console.log('on connect');
                console.log(data)
                setTranscriptSegments(data.audioDiarization);
                setAudioData(data.audioData);
                setDetailTopicSocket(data.detailTopic);
                setMainTopicSocket(data.mainTopic);
                setAgendaSocket(data.agenda);
                setAudioProgress(data.audioData.progress);
                console.log(audioProgress);
                console.log("connected");
                setSocketConnection(false);
            }
            else if (data.audioProgress) {
                console.log('audio_progress');
                setAudioProgress(data.audioProgress);
            }
            else if (data.audioTranscript) {
                console.log('audio_transcript');
                setTranscriptSegments(data.audioTranscript);
                console.log(data)
            } else if (data.audioSummary) {
                console.log('audioSummary');
                setTranscriptSegments(data.audioSummary);
                console.log(data)
            } else if (data.detailTopic) {
                console.log('detailTopic');
                setDetailTopicSocket(prevState => ({
                    ...prevState,
                    items: data.detailTopic 
                }));
                console.log(data)
            } else if (data.mainTopic) {
                console.log('mainTopic');
                setMainTopicSocket(data.mainTopic);
                console.log(data)
            } else if (data.qnaTopic) {
                console.log('qnaTopic');
                console.log(data)
            } else if (data.agenda) {
                console.log('agenda');
                setAgendaSocket(data.agenda)
                console.log(data)
            } else {

                console.log("Else")
                console.log("data")
                console.log(data)
            }
        };


        return () => {
            ws.close();
        };
    }, []);

    // Function to filter transcriptSegments based on checkedIndexes
    const getFilteredTranscriptSegments = () => {
        if (!transcriptSegments || !transcriptSegments.text) {
            return { text: [] }; // or any default value appropriate for your application
        }
        if (checkedIndexes.length === 0) {
            return transcriptSegments; // Return all items if no checkboxes are checked
        } else {
            // Filter to only include segments where the speakerId is in checkedIndexes
            return {
                ...transcriptSegments,
                text: transcriptSegments.text.filter((item) => checkedIndexes.includes(item.speakerId) && item.text.trim() !== '')
            };
        }
    };


    // Use this filtered data for rendering
    const filteredTranscriptSegments = getFilteredTranscriptSegments();

    useEffect(() => {
        if (filteredTranscriptSegments && Array.isArray(filteredTranscriptSegments.text)) {
            textRefs.current = filteredTranscriptSegments.text.map((_, i) => textRefs.current[i] || createRef());
        }
    }, [filteredTranscriptSegments.text]);



    // Diarization and Summarized text block
    const DiarizationText = React.forwardRef(({ item, index, highlight }, ref) => (
        <div className="card-body rounded-3 truncate" style={{ 
            backgroundColor: highlight ? '#bde6f9' : '#f1f3f4',
            color: highlight ? '#000000' : '#000000' // Change text colors accordingly
          }}  ref={ref}>
            {renderTextContent(item, index)}
        </div>
    ));

    const SummaryTimestamp = ({ timestamp, onClick }) => (
        <a style={{ cursor: 'pointer' }} class="flex-fill fw-600 text-body" onClick={() => onClick(timestamp)}>{timestamp}<i class="bi bi-arrow-right-short"></i></a>
    );

    const tabContents = [
        // Text
        <>
            {socketConnection ? (<>
                {/* Loading */}
                <div className="login" style={{ minHeight: '80vh', padding: 0 }}>
                    <div className="" style={{ width: 170, marginTop: 0, marginRight: 'auto', marginBottom: 0, marginLeft: 'auto' }}>
                        <RobotLoadingAnimation />
                        <div class="text-body text-opacity-50 text-center mb-4">
                            로딩중입니다...
                        </div>
                    </div>
                </div>

            </>) : (<>

                {/* successfully connected */}
                {filteredTranscriptSegments && (<div id="AudioDiarization" role="tabpanel">

                    <div className={""}>
                        <div class="tab-content">
                            {/* {transcriptSegments.text.map((item, index) => (
            <div className='card-body'>
                <div className="card" style={{ marginBottom: 25 }}>
                    <div className="card-header d-flex align-items-center bg-none">
                        <span class="flex-grow-1"><span className='fw-bold' style={{ marginRight: 20 }}>{transcriptSegments.speakers[item.speakerId]}</span>  {item.timestamp}</span>
                        <span className="flex-grow-1"> </span>
                        {renderEditButtons(index)}
                    </div>
                    <div className="card-body bg-light">
                        {renderTextContent(item, index)}
                    </div>
                </div>
            </div>
        ))} */}
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-md-6 col-sm-12 order-2 order-md-1' style={{ marginTop: 15 }}>
                                        <div className='card'>
                                            <div class="card-header d-flex align-items-center bg-white fw-bold ">
                                                <div style={{ width: 30, marginRight: 10 }}><AudioAnimation /> </div> 음성 기록
                                                {/* <a href="#" class="ms-auto text-decoration-none text-body text-opacity-50 fs-13px d-flex align-items-center"><i class="fas fa-download fs-4 me-2 my-n1"></i>다운받기</a> */}
                                            </div>
                                            <div className='card-body '>
                                                {filteredTranscriptSegments.text && filteredTranscriptSegments.text.map((item, index) => (
                                                    <div className="widget-chat" key={index}>
                                                        <div class="widget-chat-item" style={{ alignItems: "flex-start" }}>
                                                            <div class="widget-chat-media" style={{ width: '2.40rem' }}><img src={filteredTranscriptSegments.images[item.speakerId]} alt="" /></div>
                                                            <div class="widget-chat-content">
                                                                <div class="d-flex justify-content-between align-items-center">
                                                                    <div class="widget-chat-name text-dark">{filteredTranscriptSegments.speakers[item.speakerId]}</div>
                                                                    {/* <div class="text-body text-opacity-50 text-decoration-none">
                                                                        {renderEditButtons(index)}
                                                                    </div> */}
                                                                </div>
                                                                <DiarizationText
                                                                    index={index}
                                                                    item={item}
                                                                    highlight={highlightedBlocks.includes(index)}
                                                                    ref={textRefs.current[index]}
                                                                />
                                                                <div class="widget-chat-status">{item.timestamp}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {
                                                    filteredTranscriptSegments.loading && (<>
                                                        <div class="widget-chat ">
                                                            <div class="widget-chat-item">
                                                                <div class="widget-chat-media"><img src="https://static.worksmobile.net/static/pwe/wm/common/img_profile_group2.png" alt="" /></div>
                                                                <div class="widget-chat-content">
                                                                    <div class="d-flex justify-content-between align-items-center">
                                                                        <div class="widget-chat-name text-light rounded skeleton-loading">참여자 3</div>
                                                                        <div class="text-body text-opacity-50 text-decoration-none skeleton-loading">
                                                                            <i class="fa fa-fw fa-edit text-light bg-light rounded"></i>
                                                                        </div>
                                                                    </div>
                                                                    <div class="card-body rounded last text-light skeleton-loading">
                                                                        먼저 인사드리겠습니다. 이번에 대웅과 함께 유통을 하고 마케팅을 같이 하게 된 스카이웨어스의 마케팅 파트를 맡고 있는 송강 파트장입니다.
                                                                    </div>
                                                                    <div class="widget-chat-status text-light skeleton-loading">00:00:00</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>)
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-sm-12 order-1 order-md-2' style={{ marginTop: 15 }}>
                                        <div className='card mb-2'>
                                            <div class="card-header d-flex align-items-center bg-white fw-bold">
                                                <i className='fas fa-users fs-4 me-2 my-n1' />참여자
                                                {renderEditSpeaker()}
                                            </div>
                                            <div className='card-body' style={{ marginRight: 20, marginLeft: 20 }}>
                                                <div class="widget-reminder">

                                                    {/* Speakers loading  */}
                                                    {transcriptSegments.speakers.length >= 1 ? (<>
                                                        {transcriptSegments.speakers.map((item, index) => (
                                                            <>
                                                                <div class="widget-reminder-item">
                                                                    <div class="widget-chat-media d-flex align-items-center">
                                                                        {/* Checkbox */}
                                                                        <div class="form-check">
                                                                            <input type="checkbox" class="form-check-input" id={index}
                                                                                onChange={e => handleCheckboxChange(index, e.target.checked)} />
                                                                            <label class="form-check-label" for={index}></label>
                                                                        </div>

                                                                    </div>
                                                                    <div class="widget-chat-media"><img src={transcriptSegments.images[index]} width={45} alt="" /></div>
                                                                    <div class="widget-reminder-content">

                                                                        <div class="fw-bold" >{renderSpeakerName(item, index)}</div>

                                                                    </div>

                                                                </div>
                                                            </>
                                                        ))}
                                                    </>) : (<>
                                                        <div class="widget-reminder-item">

                                                            <div class="widget-chat-media skeleton-loading"><img className="" src="https://static.worksmobile.net/static/pwe/wm/common/img_profile_group2.png" width={45} alt="" /></div>
                                                            <div class="widget-reminder-content">

                                                                <div class="fw-bold skeleton-loading" >참여자 1</div>

                                                            </div>

                                                        </div>
                                                    </>)}


                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div class="card-header d-flex align-items-center bg-white fw-bold">

                                                <div style={{ width: 30 }}><AiAnimation /> </div>

                                                {/* <i className='fas fa-space-shuttle fs-4 me-2 my-n1' /> */}
                                                AI 메모
                                                {audioProgress == '완료' ? (<>
                                                    <a href={`https://meeting.daewoongai.com/api/download_summary/${id}/`} class="ms-auto text-decoration-none text-primary text-opacity-75 fs-13px d-flex align-items-center"><i class="fas fa-download fs-4 me-2 my-n1"></i>다운받기</a>
                                                </>) : (<>
                                                    <a onClick={() => showWarning("발화 요약 완료될 때까지 기다려주십시오!")} class="ms-auto text-decoration-none text-primary text-opacity-75 fs-13px d-flex align-items-center"><i class="fas fa-download fs-4 me-2 my-n1"></i>다운받기</a>
                                                </>)}

                                            </div>
                                            <div className="card-body">

                                            {
                                            transcriptSegments.summary.length >= 1 ? (<>
                                                {transcriptSegments.summary.map((item, index) => (<>
                                                    <div className="card mb-2">
                                                        <div class="card-body">
                                                            <div class="mb-3 fw-semibold d-flex align-items-center">
                                                                <SummaryTimestamp
                                                                    key={index}
                                                                    timestamp={item.timestamp}
                                                                    onClick={handleSummaryClick}
                                                                />
                                                            </div>
                                                            <div class="row mb-1">
                                                                <div class="col-lg-12 position-relative">
                                                                    {/* <h3 class="mb-0 d-flex">
                                                            302
                                                            <span class="text-body fs-10px badge bg-body my-5px d-flex align-items-center ms-2">
                                                                <i class="fa fa-exclamation-circle fa-fw fa-lg me-1 text-warning"></i>
                                                                3 pending orders
                                                            </span>
                                                        </h3> */}
                                                                    <div class="fs-13px mt-2"><p style={{ whiteSpace: 'pre-line' }}>{item.text}</p></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>))}

                                                {/* Loading */}
                                                {filteredTranscriptSegments.summary_loading && (<>
                                                    <div class="widget-reminder-item">
                                                        <div class="widget-reminder-time d-flex align-items-center skeleton-loading">01:34</div>
                                                        <div class="widget-reminder-content">
                                                            <div class="fw-bold skeleton-loading" style={{ marginBottom: 8 }}>삼성, 갤력시 s7에 탑재된 기술 특허 등록</div>
                                                            <div class="fs-13px skeleton-loading" style={{ marginBottom: 8 }}><i class="fa fa-circle fs-4px fa-fw text-muted me-1"></i> 스타트업이기 때문에 버릴 수는 없어서 잠깐 잠정적 스톱을 한 거지 접은 건 아님 </div>
                                                            <div class="fs-13px skeleton-loading"><i class="fa fa-circle fs-4px fa-fw text-muted me-1"></i> 스타트업이기 때문에 버릴 수는 없어서 잠깐 잠정적 스톱을 한 거지 접은 건 아님 </div>
                                                        </div>
                                                    </div>
                                                </>)}
                                            </>)

                                                : (<>
                                                    <div class="widget-reminder-item">
                                                        <div class="widget-reminder-time d-flex align-items-center skeleton-loading">01:34</div>
                                                        <div class="widget-reminder-content">
                                                            <div class="fw-bold skeleton-loading" style={{ marginBottom: 8 }}>삼성, 갤력시 s7에 탑재된 기술 특허 등록</div>
                                                            <div class="fs-13px skeleton-loading"><i class="fa fa-circle fs-4px fa-fw text-muted me-1"></i> 스타트업이기 때문에 버릴 수는 없어서 잠깐 잠정적 스톱을 한 거지 접은 건 아님 </div>
                                                        </div>
                                                    </div>
                                                </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div >)}
            </>)}

        </>

        ,
        // Summary

        <div id="Summary" role="tabpanFel">
            <div className="row">
                <div className="col-lg-4 col-xl-4 col-sm-12">
                    {
                        agendaSocket != null &&

                        <AgendaComponent id={id} audioData={audioData} agendaSocket={agendaSocket} />

                    }
                </div>
                <div className="col-lg-8 col-xl-8 col-sm-12">
                    {/* <MainTable/> */}
                    <div className='card'>
                        <div class="card-header d-flex align-items-center bg-white fw-bold ">
                            <i class="bi-clipboard-check text-black my-n1 fs-4 me-2"></i>발화 요약 <div style={{ width: 30 }}><AiAnimation /> </div>
                            {audioProgress == '완료' ? (<>
                                <a href={`https://meeting.daewoongai.com/api/download_meeting/${id}/`} class="ms-auto text-decoration-none text-primary text-opacity-75 fs-13px d-flex align-items-center"><i class="fas fa-download fs-4 me-2 my-n1"></i>다운받기</a>
                            </>) : (<>
                                <a onClick={() => showWarning("회의록 완료될 때까지 기다려주십시오!")} class="ms-auto text-decoration-none text-primary text-opacity-75 fs-13px d-flex align-items-center"><i class="fas fa-download fs-4 me-2 my-n1"></i>다운받기</a>
                            </>)
                            }
                        </div>
                        <div className='row'>

                            {/* sub topic data */}
                            {mainTopicSocket != null && <MainTable mainTopicSocket={mainTopicSocket} setMainTopicSocket={setMainTopicSocket} id={id} />}

                            {detailTopicSocket != null && <SummaryTable detailTopicSocket={detailTopicSocket} mainTopicSocket={mainTopicSocket} setDetailTopicSocket={setDetailTopicSocket} id={id} />}
                            {/* <QnATable/> */}
                            {/* Content for Text tab */}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        // // Draft Article
        // <div id="DraftArticle" role="tabpanel">
        //     <h3 className="text-center">Draft Article</h3>
        //     <div class="d-flex justify-content-center">

        //         <div class="col-md-8 col-xl-6 col-lg-10 col-sm-12">
        //             <div class="form-group mb-3">
        //                 <label class="form-label" for="exampleFormControlInput1">Text input</label>
        //                 <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com" />
        //             </div>
        //             <div class="form-group mb-3">
        //                 <label class="form-label" for="exampleFormControlTextarea1">Textarea</label>
        //                 <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
        //             </div>
        //             <div class="form-group mb-3">
        //                 <label class="form-label" for="exampleFormControlFile1">File input</label>
        //                 <input type="file" class="form-control" id="exampleFormControlFile1" />
        //             </div>
        //         </div>
        //     </div>
        //     {/* Content for Draft Article tab */}
        // </div>
    ];
    return (
        <>
            {/* {navTable == 0 && (
                    <>
                        {transcriptSegments && (
                            <div className="col-lg-4 col-xl-3 col-sm-12">
                                <div className="card shadow" style={{ marginBottom: 15 }}>
                                    <div class="card-header d-flex align-items-center bg-none">
                                        <span class="flex-grow-1 fw-bold">발화문서 설정</span>
                                        {renderEditSpeaker()}
                                    </div>
                                    <div className="card-body">
                                        <table class="table">
                                            <tbody>
                                                {transcriptSegments.speakers.map((item, index) => (
                                                    <tr>
                                                        <td>{renderSpeakerName(item, index)}</td>
                                                    </tr>
                                                ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )} */}


            {/* Body content */}
            <div className={navTable == 0 ? "col-lg-12 col-xl-12 col-sm-12" : "col-12"}>

                <div className="bg-white" style={{ marginBottom: 8 }}>
                    <ul className="nav nav-tabs nav-tabs-v2 px-3" role="tablist">
                        <li className={`nav-item me-2 ${navTable === 0 ? 'active' : ''}`} role="presentation">
                            <a
                                className={`nav-link px-2 ${navTable === 0 ? 'active' : ''}`}
                                onClick={() => setActiveTab(0)}
                                role="tab"
                            >
                                발화 요약 📝
                            </a>
                        </li>
                        {audioData?.type === '회의록' &&
                            <li className={`nav-item me-2 ${navTable === 1 ? 'active' : ''}`} role="presentation">
                                <a
                                    className={`nav-link px-2 ${navTable === 1 ? 'active' : ''}`}
                                    onClick={() => setActiveTab(1)}
                                    role="tab"
                                >
                                제품 자문 회의록 ✍️
                                </a>
                            </li>
                        }
                    </ul>


                </div>
                <div className={navTable == 0 ? "container-xl" : "container-fluid"}>
                    {tabContents[navTable]}
                </div>
            </div>
        </>
    )
}

export default AudioDiarizationComponent;